import LoginDialogFields from "../../../shared/dialog/fields/LoginDialogFields";
import DialogType from "../DialogType";
import Fields from "./Fields";
import FunctionHelper from "../../helper/FunctionHelper";

class DialogFields {
	private static _instance: DialogFields;
	private _fields: Map<DialogType, Fields>;

	private constructor() {
		this._fields = new Map<DialogType, Fields>([
			[
				DialogType.LOGIN,
				new Fields([
					LoginDialogFields.PASSWORD,
					LoginDialogFields.USERNAME,
				])
			]
		]);
	}

	get fields(): Map<DialogType, Fields> {
		return this._fields;
	}

	public static get instance(): DialogFields {
		return FunctionHelper.applyValue(this._instance, (this._instance = new this()));
	}
}

export default DialogFields.instance;